<template>
    <div :class="$style.wrapper">
        <DateFilter
            :currDate.sync="dateType"
            :dateRange.sync="dateRange"
            :handleClick="getData"
        ></DateFilter>
        <div :class="$style.table">
            <el-table
                :data="tableData"
                v-loading="loading"
                style="width: 100%"
            >
                <el-table-column align="center" label="下单时间" prop="addtime"></el-table-column>
                <el-table-column align="center" label="订单编号" prop="order_sn"></el-table-column>
                <el-table-column align="center" label="成交金额" prop="order_prices"></el-table-column>
                <el-table-column align="center" label="买家" prop="buyers"></el-table-column>
                <!--<el-table-column align="center" label="经销商价" prop="memer_price"></el-table-column>-->
                <!-- <el-table-column align="center" label="利润" prop="order_prices-member_price"></el-table-column> -->
                <!-- <el-table-column align="center" label="合计" prop="buyers"></el-table-column> -->
                <el-table-column align="center" label="佣金">
                    <template slot-scope="scope">
                        <span style="color: #f74845">{{scope.row.commission}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="来源店员" prop="source_clerk"></el-table-column>
            </el-table>

        </div>
        <Pagination
            v-if="tableData.length > 0"
            :currPage.sync="currPage"
            :pageCount="pageCount"
            :pageChange="getData"
        ></Pagination>
    </div>
</template>

<script>
    import Vue from 'vue';
    import DateFilter from '../components/Common/DateFilter.vue';
    import Pagination from '../components/Common/Pagination.vue';
    import { getBrokerageDetail } from '../stores/api';

    Vue.component('DateFilter', DateFilter);
    Vue.component('Pagination', Pagination);
    export default {
        data () {
            return {
                loading: false,
                tableData: [],
                dateRange: null,
                dateType: null,
                currPage: 1,
                pageCount: 1,
            };
        },
        beforeMount () {
            this.getData();
        },
        methods: {
            getData () {
                let temp = {page: this.currPage};
                if (this.dateType) {
                    temp.typetime = this.dateType;
                } else if (this.dateRange) {
                    temp.starttime = Date.parse(this.dateRange[0]) / 1000;
                    temp.endtime = Date.parse(this.dateRange[1]) / 1000 + 24 * 60 * 60;
                }
                this.loading = true;
                getBrokerageDetail(temp).then(res => {
                    console.log(res.data)
                    this.tableData = res.data.commission_list;
                    this.currPage = res.data.page;
                    this.pageCount = res.data.pagecount;
                    this.loading = false;
                });
            }
        }
    };
</script>

<style lang="less" module>
    .wrapper {
        .table {
            padding-top: 30px;
            border-top: 2px solid #dfe4ed;
            :global {
                .el-table {
                    border: 1px solid #d8dde6;
                    th {
                        background: #F2F4F5;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/router/Brokerage.vue